
interface props {
    labelName: any;
    // style: any,
    isRequired?:boolean
}
const LabelInput = ({ labelName, isRequired}: props) => {
    return (
        <div className="mb-2">
            <label className="label font14 fw-bold">
                {labelName}
                {isRequired ? <span className="required ms-1 fs-6">*</span> : null}
            </label>
        </div>
    );
};
export default LabelInput;
